<template>
  <div>
    <div v-if="uploading">
      Uploading...
    </div>
    <div>
      <b-button variant="outline-primary" @click="select()">
        {{ label }}
      </b-button>
    </div>
    <input ref="fileInput" type="file" :accept="accept" />
    <img
      v-if="displayValue"
      :src="'https://cdn.gokaizen.com/' + displayValue"
      @click="select()"
    />
  </div>
</template>

<script>
import $api from '@/services/api';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    folder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: '*',
    },
    labelExtra: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      uploading: false,
      displayValue: this.value,
    };
  },

  computed: {
    label() {
      const extra = this.labelExtra ? ` ${this.labelExtra}` : '';
      return this.value ? `Change${extra}` : `Select${extra}`;
    },
  },

  watch: {
    value(newValue) {
      this.displayValue = newValue;
    },
  },

  mounted() {
    const { fileInput } = this.$refs;

    // eslint-disable-next-line consistent-return
    fileInput.addEventListener('change', () => {
      if (!this.folder) {
        return false;
      }

      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];

        $api
          .post('/v1/common/cdnitem', {
            folder: this.folder,
            type: file.type,
          })
          .then((uploadInfo) => {
            this.uploading = true;
            const xhr = new XMLHttpRequest();
            xhr.open('PUT', uploadInfo.url);
            xhr.onreadystatechange = () => {
              if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                  this.displayValue = uploadInfo.id;
                  this.uploading = false;
                  this.$emit('input', uploadInfo.id);
                }
              }
            };
            xhr.send(file);
          });
      }
    });
  },

  methods: {
    select() {
      this.$refs.fileInput.click();
    },
  },
};
</script>

<style scoped>
img {
  max-width: 300px;
  margin-top: 10px;
}

input[type='file'] {
  display: none;
}

button {
  width: 100%;
}
</style>
